<script>
import { mapGetters } from "vuex";
import moment from "moment";
import Bahn1CountdownTimer from "@/components/ui/Bahn1/Bahn1CountdownTimer.vue";

export default {
  name: "Bahn1EventDetails",
  components: { Bahn1CountdownTimer },
  computed: {
    ...mapGetters("bahn1", ["termin", "ort"]),
    parsedDate() {
      return moment(this.termin.Tag).toDate();
    },
    dow() {
      return this.parsedDate.toLocaleDateString("de-DE", { weekday: "long" });
    },
    longDate() {
      const d = this.parsedDate;
      return `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()}`;
    },
    beginn() {
      return this.formatTime(this.termin.Beginn);
    },
    ende() {
      return this.formatTime(this.termin.Ende);
    }
  },
  methods: {
    formatTime(time) {
      if (!time) return "";
      const [hours, minutes] = time.split(":");
      return `${hours}:${minutes} Uhr`;
    }
  }
};
</script>

<template>
  <div class="event-details" v-if="termin && ort">
    <v-row no-gutters>
      <v-col cols="12" md="6">
        <v-row no-gutters>
          <v-col cols="12" sm="6" class="info-col">
            <span class="info-label">Termin</span>
            <p>
              {{ dow }}, {{ longDate }} <br />
              Beginn: {{ beginn }} <br />
              Ende: {{ ende }}
            </p>
          </v-col>
          <v-col cols="12" sm="6" class="info-col">
            <span class="info-label">Ort</span>
            <p>
              {{ ort.Zeile1 }} <br />
              {{ ort.Strasse }} {{ ort.Strassennummer }} <br />
              {{ ort.Postleitzahl }} {{ ort.Ort }}
            </p>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="6" class="timer-col">
        <bahn1-countdown-timer />
      </v-col>
    </v-row>
    <div class="separator" />
  </div>
</template>

<style scoped>
.event-details {
  position: relative;
  width: 100%;
  min-height: 110px;
  padding: 16px 24px;
  background: #008cc8;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 0;
}
.separator {
  position: absolute;
  left: 50%;
  top: 7px;
  bottom: 7px;
  width: 2px;
  background: #ffffff;
  transform: translateX(-1px);
}
.info-col {
  padding: 0 16px;
}
.info-label {
  font-family: "GeometriaLight";
  font-size: 12px;
  line-height: 1.2;
  letter-spacing: 0.6px;
}
.timer-col {
  display: flex;
  align-items: center;
  justify-content: center;
}

p {
  margin: 0;
  font-family: "GeometriaLight";
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: 0.28px;
}
@media (max-width: 959px) {
  .separator {
    display: none;
  }
  .timer-col {
    padding-top: 32px;
  }
}
@media (max-width: 599px) {
  .event-details {
    padding: 16px;
  }
  .info-col {
    text-align: center;
  }
  .info-col + .info-col {
    padding-top: 16px;
  }
}
</style>
